import React, { FC } from 'react'
import { Grid } from '@material-ui/core'
import useStyles from './styles'
import RightSide from './RightSide'
import LeftSide from './LeftSide'
import { EnvConfig } from '@pages/video-script-generator'

interface IScriptStepProps {
  scriptResult: {
    videoScript?: string;
    contentScript?: string;
    subjectScript?: string;
  };
  back: () => void;
  generateEmailScript: () => void;
  handleScriptContentOpener: (text: string, section: string) => void;
  loading?: boolean;
  env: EnvConfig;
}

const ScriptStep: FC<IScriptStepProps> = ({ back, scriptResult, generateEmailScript, handleScriptContentOpener, loading = false, env }) => {
  const classes = useStyles()
  return (
    <Grid container spacing={3} className={classes.root}>
      <Grid item md={6} xs={12} className={classes.panels}>
        <Grid className={classes.leftSideContainer}>
          <LeftSide onBack={back} scriptResult={scriptResult} generateEmailScript={generateEmailScript} handleScriptContentOpener={handleScriptContentOpener} loading={loading} />
        </Grid>
      </Grid>
      <Grid item md={6} xs={12} className={classes.panels}>
        <Grid className={classes.rightSideContainer}>
          <RightSide env={env} />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ScriptStep
